import { Box, Button, FormControl, Grid, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import { actions } from '../../../actions';
import collections from '../../../constants/FirestoreCollections';

const useStyles = makeStyles((theme) => ({
  formControl: {
    paddingBlock: 16,
  },
}));

export default function LabelsConfig(props) {
  const classes = useStyles();

  // hooks
  const firestore = useFirestore();
  const appDispatch = useDispatch();

  // redux
  const configuration = useSelector((state) => state.app.labelsConfiguration);

  // states
  const [localConfiguration, setLocalConfiguration] = useState({});

  const handleSaveConfiguration = () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firestore
      .collection(collections.configurations)
      .where('name', '==', 'labels')
      .get()
      .then((res) => {
        if (!res.empty) {
          const configId = res && res.docs && res.docs[0] && res.docs[0].id;
          firestore
            .collection(collections.configurations)
            .doc(configId)
            .update(localConfiguration)
            .then(() => {
              appDispatch({
                type: actions.labelsConfiguration,
                labelsConfiguration: localConfiguration,
              });
              appDispatch({
                type: actions.alert,
                alert: {
                  snackbarOpen: true,
                  snackbarMessage: 'Actualizado exitosamente!',
                  snackbarSeverity: 'success',
                },
              });
            })
            .catch((err) => {
              // eslint-disable-next-line no-console
              console.log(err);
              appDispatch({
                type: actions.alert,
                alert: {
                  snackbarOpen: true,
                  snackbarMessage: 'Error al actualizar!',
                  snackbarSeverity: 'error',
                },
              });
            });
        }
      })
      .catch(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Error al actualizar!',
            snackbarSeverity: 'error',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  // effects
  useEffect(() => {
    setLocalConfiguration(configuration);
  }, [configuration]);

  return (
    <Box>
      <Typography>
        <b>CONFIGURACIÓN TEXTO DE PANTALLAS</b>
      </Typography>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Mensajes de sistema</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.systemMessages) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                systemMessages: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Mensajes institucionales</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.institutionalMessages) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                institutionalMessages: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Mensajes de obras sociales</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.osMessages) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                osMessages: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Mensajes de modalidades</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.modalities) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                modalities: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Seccion de webchat</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.webchat) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                webchat: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Seccion de plantillas</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.templates) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                templates: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Seccion de usuarios</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.users) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                users: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Seccion de filtros para recordatorios</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.reminders) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                reminders: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Seccion de filtros para recordatorios de obras sociales por especialidad</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={
              (localConfiguration && localConfiguration.remindersSpecialtiesByInsurances) || ''
            }
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                remindersSpecialtiesByInsurances: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} xl={6}>
        <FormControl className={classes.formControl} fullWidth>
          <span>Seccion de especialidades</span>
          <TextField
            id="outlined-multiline-static"
            multiline
            value={(localConfiguration && localConfiguration.specialties) || ''}
            onChange={(e) =>
              setLocalConfiguration({
                ...localConfiguration,
                specialties: e.target.value,
              })
            }
            rows={6}
            variant="outlined"
            spellCheck="false"
          />
        </FormControl>
      </Grid>
      <FormControl className={classes.formControl}>
        <Button variant="contained" color="primary" onClick={handleSaveConfiguration}>
          Guardar
        </Button>
      </FormControl>
    </Box>
  );
}
